import React from "react";

const FAQ = () => {
  return (
    <div className="about-container">
      <h1 className="text-3xl font-bold mb-4">Frequently Asked Questions (FAQ)</h1>

      <div className="space-y-6">
        <div>
          <h2 className="text-2xl font-semibold">Q1: What is jsonconverter.org?</h2>
          <p>jsonconverter.org is a free online platform that allows you to format, validate, and convert JSON, XML, YAML, and other formats to multiple programming languages like C, C++, C#, Java, PHP, Python, GO</p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold">Q2: Is jsonconverter.org free to use?</h2>
          <p>Yes! All tools on jsonconverter.org are completely free for personal and professional use.</p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold">Q3: Do I need to create an account?</h2>
          <p>No account is required. You can use our tools instantly without registration.</p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold">Q4: How secure is my data?</h2>
          <p>We do not store your data permanently. All processing happens in your browser or temporarily on our servers for conversion. We use security measures to protect your privacy.</p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold">Q5: Can I convert large files?</h2>
          <p>Yes, but there may be limitations depending on your browser and internet connection.</p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold">Q6: Which formats can I convert?</h2>
          <p>JSON, XML, YAML, CSV, and Convert Json to various programming language formats.</p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold">Q7: Is Login required to doownload JSON data / Code ??</h2>
          <p>No. It's not required to doownload and save code.</p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold">Q8: Can I use jsonconverter.org for commercial projects?</h2>
          <p>Yes, our tools can be used for both personal and commercial purposes without restriction.</p>
        </div>

      </div>
    </div>
  );
};

export default FAQ;
